const HOST_PRINTER = "HOST_PRINTER";
const DEFAULT_HOST = "http://localhost:8000";
class PrintConfig{
    static getHost(){
        const host = localStorage.getItem(HOST_PRINTER);
        return host ? host : DEFAULT_HOST;
    }

    static setHost(host:any){
        localStorage.setItem(HOST_PRINTER,host);
    }
}

export default PrintConfig;